import React from 'react';
import YouTube, { PlayerState } from 'react-youtube';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getVideo } from '~/actions/video'
import { updateViewHistory, postViewHistory } from '~/actions/viewhistory'

import VideoLoader from '~/components/Loaders/Video'


class Video extends React.Component {
    constructor(props) {
        super(props);

        let state = {
			post: {},
			videoReady: false
		}

        var passedPost = props.location.state && 'video' in props.location.state ? props.location.state.video : false,
			passedPostMatches = !!passedPost && passedPost.slug === props.match.params.slug;
        if( !!passedPost && passedPostMatches ) state.post = passedPost

        this.state = state;
    }

    watched = 0;

    componentWillMount() {
		if( !('ID' in this.state.post) ) this.props.getVideo( this.props.match.params.slug )
	}

    componentDidMount() {
		this.props.postViewHistory( 'statements', this.props.match.params.slug )
	}

    updateWatched = (event) => {
		this.watched = event.target.getCurrentTime()
	};

    makeReady = () => {
		this.setState({
			videoReady: true
		})
	};

    render() {

		let { post, fetching } = this.props.video;
		if( 'ID' in this.state.post ) post = this.state.post;

		let matches = 'ID' in post ? post.preview.data.video.match(/(youtu(?:\.be|be\.com)\/(?:.*v(?:\/|=)|(?:.*\/)?)([\w'-]+))/) : [],
			youtubeID = !!matches.length ? matches[2] : '';

		return (
            <div className="container pbot40">

                {/*<Filters filteredSlug={slug} />*/}
                <button
                    className="no-style mbot20 back-arrow"
                    onClick={this.props.history.goBack}
                >
                    <i className="icon-arrow-left" />
                    <span>Back</span>
                </button>

                <div className="embed-responsive embed-responsive-16by9">

                    { !youtubeID &&
                    	<VideoLoader />
                    }

                    { !!youtubeID &&
						<YouTube
							videoId={youtubeID}
							className="embed-responsive-item"
							onReady={this.makeReady}
							onPause={this.updateWatched}
							onEnd={this.updateWatched}
							opts={{
								//height: this.props.video.height,
								//width: this.props.video.width,
								playerVars: { //https://developers.google.com/youtube/player_parameters
									autoplay: 1,
									controls: 1,
									showinfo: 0,
									modestbranding: 0,
									rel: 0
								}
							}}
						/>
                    }

                    { !!youtubeID && !this.state.videoReady &&
                    	<img src={post.preview.data.image} className="img-responsive" />
                    }

                </div>

                <h1 className="mtop10 mbot20">{ post.title }</h1>

            </div>
		)
		
	}

    componentWillUnmount() {
		this.props.updateViewHistory( 'statements', this.props.match.params.slug, this.watched )
	}
}

const mapStateToProps = state => ({
    video: state.video
});

const mapDispatchToProps = dispatch => bindActionCreators({ getVideo, postViewHistory, updateViewHistory }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Video);




// WEBPACK FOOTER //
// ./src/js/views/Video/index.js